import { render, staticRenderFns } from "./HeaderLanguage.vue?vue&type=template&id=1623b7b7&"
import script from "./HeaderLanguage.vue?vue&type=script&lang=ts&"
export * from "./HeaderLanguage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports